export const HOST_REQUEST = 'CUSTOMIZATION_HOST_REQUEST';
export const HOST_SUCCESS = 'CUSTOMIZATION_HOST_SUCCESS';
export const HOST_FAILURE = 'CUSTOMIZATION_HOST_FAILURE';
